import { render, staticRenderFns } from "./PublicWelfareMap.vue?vue&type=template&id=7bddf538&scoped=true"
import script from "./PublicWelfareMap.vue?vue&type=script&lang=js"
export * from "./PublicWelfareMap.vue?vue&type=script&lang=js"
import style0 from "./PublicWelfareMap.vue?vue&type=style&index=0&id=7bddf538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bddf538",
  null
  
)

export default component.exports